import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TrendingDownIcon, PieChartIcon } from 'lucide-react';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
export function InsightsScreen() {
  return <div className="space-y-6" data-id="element-852">
      {/* Header */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-853">
        <h1 className="text-2xl font-bold mb-2" style={{
        color: OPENFINANCE_THEME.colors.text,
        fontFamily: OPENFINANCE_THEME.fonts.heading
      }} data-id="element-854">
          Financial Insights
        </h1>
        <p className="text-sm" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-855">
          Understand your spending patterns and find ways to save
        </p>
      </motion.div>

      {/* Coming Soon Card */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="bg-white border-2 rounded-2xl p-12 text-center" style={{
      borderColor: OPENFINANCE_THEME.colors.border
    }} data-id="element-856">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center" style={{
        backgroundColor: OPENFINANCE_THEME.colors.accent500 + '15'
      }} data-id="element-857">
          <PieChartIcon className="w-8 h-8" style={{
          color: OPENFINANCE_THEME.colors.accent500
        }} data-id="element-858" />
        </div>
        <h2 className="text-xl font-bold mb-2" style={{
        color: OPENFINANCE_THEME.colors.text,
        fontFamily: OPENFINANCE_THEME.fonts.heading
      }} data-id="element-859">
          Detailed Insights Coming Soon
        </h2>
        <p className="text-sm max-w-md mx-auto" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-860">
          We're building advanced analytics to help you understand your spending
          trends, set budgets, and reach your financial goals faster.
        </p>
      </motion.div>

      {/* Preview Features */}
      <div className="grid md:grid-cols-2 gap-4" data-id="element-861">
        {[{
        icon: TrendingUpIcon,
        title: 'Spending Trends',
        description: 'Track how your spending changes over time',
        color: OPENFINANCE_THEME.colors.primary500
      }, {
        icon: PieChartIcon,
        title: 'Category Breakdown',
        description: 'See where your money goes each month',
        color: OPENFINANCE_THEME.colors.accent500
      }, {
        icon: TrendingDownIcon,
        title: 'Budget Tracking',
        description: 'Set limits and stay on track',
        color: OPENFINANCE_THEME.colors.success
      }, {
        icon: TrendingUpIcon,
        title: 'Savings Goals',
        description: 'Plan and achieve your financial targets',
        color: OPENFINANCE_THEME.colors.warning
      }].map((feature, index) => {
        const Icon = feature.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="bg-white border-2 rounded-xl p-5" style={{
          borderColor: OPENFINANCE_THEME.colors.borderLight
        }} data-id="element-862">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{
            backgroundColor: feature.color + '15'
          }} data-id="element-863">
                <Icon className="w-5 h-5" style={{
              color: feature.color
            }} data-id="element-864" />
              </div>
              <h3 className="text-base font-bold mb-1" style={{
            color: OPENFINANCE_THEME.colors.text,
            fontFamily: OPENFINANCE_THEME.fonts.heading
          }} data-id="element-865">
                {feature.title}
              </h3>
              <p className="text-sm" style={{
            color: OPENFINANCE_THEME.colors.textMuted
          }} data-id="element-866">
                {feature.description}
              </p>
            </motion.div>;
      })}
      </div>
    </div>;
}